// Tracking helpers – push events to dataLayer.
// GTM / Meta Pixel loaders are injected only AFTER consent is granted
// (see CookieBanner).

export const CONSENT_KEY = "mfp_consent_v1";

export const defaultConsent = {
  necessary: true,
  statistics: false,
  marketing: false,
  timestamp: null,
};

export function loadConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveConsent(consent) {
  localStorage.setItem(
    CONSENT_KEY,
    JSON.stringify({ ...consent, timestamp: new Date().toISOString() })
  );
  applyConsentModeUpdate(consent);
}

export function applyConsentModeUpdate(consent) {
  if (typeof window === "undefined" || !window.gtag) return;
  window.gtag("consent", "update", {
    ad_storage: consent.marketing ? "granted" : "denied",
    ad_user_data: consent.marketing ? "granted" : "denied",
    ad_personalization: consent.marketing ? "granted" : "denied",
    analytics_storage: consent.statistics ? "granted" : "denied",
  });
}

// --- Loader injections (idempotent) ---
const injected = { gtm: false, pixel: false };

export function injectGTM(gtmId) {
  if (!gtmId || injected.gtm || typeof document === "undefined") return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
  injected.gtm = true;
}

export function injectMetaPixel(pixelId) {
  if (!pixelId || injected.pixel || typeof document === "undefined") return;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
  injected.pixel = true;
}

// --- Event helpers ---
export function trackEvent(eventName, params = {}) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...params });
  if (window.fbq) {
    try {
      window.fbq("trackCustom", eventName, params);
    } catch (e) {
      /* noop */
    }
  }
}

export const trackWhatsappClick = (location = "unknown") =>
  trackEvent("whatsapp_click", { click_location: location });
export const trackPhoneClick = (location = "unknown") =>
  trackEvent("phone_click", { click_location: location });
// Backward-compatibility alias for old `call_click` event name
export const trackCallClick = trackPhoneClick;
export const trackFormSubmit = (pkg, drone) =>
  trackEvent("form_submit", { package: pkg, drone });
export const trackLeadThankYouView = (pkg, drone) =>
  trackEvent("lead_thank_you_view", { package: pkg, drone });
export const trackPageView = (path = "/") =>
  trackEvent("page_view", { page_path: path, page_title: typeof document !== "undefined" ? document.title : "" });
